<mat-drawer-container autosize class="mat-typography flex-column" title=''>

  <mat-drawer #drawerFilters mode="over" position="end" class="drawer">
    <mat-drawer-content>
      <div class="top-panel flex-row">
        <div>
          <h2>Filter receipt codes</h2>
        </div>
        <div class="text-right">
          <lib-button variant="icon" (buttonClick)="drawerFilters.toggle()" tooltip="Close" icon="close"></lib-button>
        </div>
      </div>

      <form (ngSubmit)="onSubmit()" [formGroup]="form">
        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Scanned after</mat-label>
            <input matInput type="text" [matDatepicker]="scanDateGreaterThan" placeholder=""
              formControlName="scanDateGreaterThan">
            <mat-datepicker-toggle matSuffix [for]="scanDateGreaterThan"></mat-datepicker-toggle>
            <mat-datepicker #scanDateGreaterThan></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Hour</mat-label>
            <input matInput type="text" [ngxMatTimepicker]="scanTimeGreaterThan" placeholder="" [format]="24"
              formControlName="scanTimeGreaterThan" [disableClick]="!form.value.scanDateGreaterThan"
              (click)="onTimePickerTryOpen(!form.value.scanDateGreaterThan)" readonly>
            <ngx-mat-timepicker #scanTimeGreaterThan></ngx-mat-timepicker>
            <ngx-mat-timepicker-toggle matSuffix [for]="scanTimeGreaterThan"
              [disabled]="!form.value.scanDateGreaterThan"
              (click)="onTimePickerTryOpen(!form.value.scanDateGreaterThan)">
              <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
          </mat-form-field>
        </div>
        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Scanned before</mat-label>
            <input matInput type="text" [matDatepicker]="scanDateLessThan" placeholder=""
              formControlName="scanDateLessThan">
            <mat-datepicker-toggle matSuffix [for]="scanDateLessThan"></mat-datepicker-toggle>
            <mat-datepicker #scanDateLessThan></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Hour</mat-label>
            <input matInput type="text" [ngxMatTimepicker]="scanTimeLessThan" placeholder="" [format]="24"
              formControlName="scanTimeLessThan" [disableClick]="!form.value.scanDateLessThan"
              (click)="onTimePickerTryOpen(!form.value.scanDateLessThan)" readonly>
            <ngx-mat-timepicker #scanTimeLessThan></ngx-mat-timepicker>
            <ngx-mat-timepicker-toggle matSuffix [for]="scanTimeLessThan" [disabled]="!form.value.scanDateLessThan"
              (click)="onTimePickerTryOpen(!form.value.scanDateLessThan)">
              <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
          </mat-form-field>
        </div>

        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Receipt date after</mat-label>
            <input matInput type="text" [matDatepicker]="receiptDateGreaterThan" placeholder=""
              formControlName="receiptDateGreaterThan">
            <mat-datepicker-toggle matSuffix [for]="receiptDateGreaterThan"></mat-datepicker-toggle>
            <mat-datepicker #receiptDateGreaterThan></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Hour</mat-label>
            <input matInput type="text" [ngxMatTimepicker]="receiptTimeGreaterThan" placeholder="" [format]="24"
              formControlName="receiptTimeGreaterThan" [disableClick]="!form.value.receiptDateGreaterThan"
              (click)="onTimePickerTryOpen(!form.value.receiptDateGreaterThan)" readonly>
            <ngx-mat-timepicker #receiptTimeGreaterThan></ngx-mat-timepicker>
            <ngx-mat-timepicker-toggle matSuffix [for]="receiptTimeGreaterThan"
              [disabled]="!form.value.receiptDateGreaterThan"
              (click)="onTimePickerTryOpen(!form.value.receiptDateGreaterThan)">
              <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
          </mat-form-field>
        </div>
        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Receipt date before</mat-label>
            <input matInput type="text" [matDatepicker]="receiptDateLessThan" placeholder=""
              formControlName="receiptDateLessThan">
            <mat-datepicker-toggle matSuffix [for]="receiptDateLessThan"></mat-datepicker-toggle>
            <mat-datepicker #receiptDateLessThan></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Hour</mat-label>
            <input matInput type="text" [ngxMatTimepicker]="receiptTimeLessThan" placeholder="" [format]="24"
              formControlName="receiptTimeLessThan" [disableClick]="!form.value.receiptDateLessThan"
              (click)="onTimePickerTryOpen(!form.value.receiptDateLessThan)" readonly>
            <ngx-mat-timepicker #receiptTimeLessThan></ngx-mat-timepicker>
            <ngx-mat-timepicker-toggle matSuffix [for]="receiptTimeLessThan"
              [disabled]="!form.value.receiptDateLessThan"
              (click)="onTimePickerTryOpen(!form.value.receiptDateLessThan)">
              <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
          </mat-form-field>
        </div>

        <mat-form-field class="full-width">
          <mat-label>Invoice number</mat-label>
          <input matInput type="text" placeholder="" formControlName="invoiceNumber">
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Customer Code</mat-label>
          <input matInput type="text" placeholder="" formControlName="customerCode">
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>User Id</mat-label>
          <input matInput type="text" placeholder="" formControlName="userId">
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Campaign Id</mat-label>
          <input matInput type="text" placeholder="" formControlName="campaignId">
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Card Id</mat-label>
          <input matInput type="text" placeholder="" formControlName="cardId">
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Id</mat-label>
          <input matInput type="text" placeholder="" formControlName="id">
        </mat-form-field>

        <div form-actions class="actions gap-8">
          <lib-button type="submit" variant="raised" color="primary" [disabled]="!form.valid">Search</lib-button>
          <lib-button type="reset" variant="stroked" (click)="onReset()">Reset</lib-button>
        </div>
      </form>
    </mat-drawer-content>
  </mat-drawer>
</mat-drawer-container>